import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/theme-dark.css";
import EmailSettings from "./EmailSettings";

export default function SettingsHome() {
  const navigate = useNavigate();
  const [view, setView] = useState("home"); // home | email

  /* ============================================================
        VISTA CONFIGURACIÓN DE EMAIL
  ============================================================ */
  if (view === "email") {
    return (
      <div className="page-dark">

        {/* HEADER GLASS */}
        <header
          style={{
            padding: "20px 30px",
            marginBottom: 25,
            background: "rgba(15,23,42,0.65)",
            borderBottom: "1px solid rgba(255,255,255,0.12)",
            backdropFilter: "blur(10px)",
            borderRadius: "0 0 16px 16px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.45)",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <img src="/corex-logo.png" alt="COREX" style={{ height: 40 }} />
              <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: "white" }}>
                Configuración de Email
              </h1>
            </div>

            <button
              className="glass-btn"
              style={{ fontSize: 14 }}
              onClick={() => setView("home")}
            >
              ← Volver
            </button>
          </div>

          <p style={{ opacity: 0.85, marginTop: 6 }}>
            Servidor SMTP, puertos y credenciales de envío.
          </p>
        </header>

        {/* FORMULARIO EMAIL */}
        <div className="glass-box" style={{ padding: 25 }}>
          <EmailSettings />
        </div>
      </div>
    );
  }

  /* ============================================================
        VISTA PRINCIPAL DE AJUSTES
  ============================================================ */
  return (
    <div className="page-dark">

      {/* HEADER PRINCIPAL */}
      <header
        style={{
          padding: "20px 30px",
          marginBottom: 25,
          background: "rgba(15,23,42,0.65)",
          borderBottom: "1px solid rgba(255,255,255,0.12)",
          backdropFilter: "blur(10px)",
          borderRadius: "0 0 16px 16px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.45)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <img src="/corex-logo.png" alt="COREX" style={{ height: 40 }} />
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: "white" }}>
              Ajustes del sistema
            </h1>
          </div>

          <button
            className="glass-btn"
            onClick={() => navigate("/dashboard")}
            style={{ fontSize: 14 }}
          >
            ← Volver
          </button>
        </div>

        <p style={{ opacity: 0.85, marginTop: 6 }}>
          Configura los datos principales de tu empresa, facturación y correo.
        </p>
      </header>

      {/* TARJETAS DE AJUSTES */}
      <nav
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: 20,
          paddingBottom: 20,
        }}
      >
        {/* DATOS DE EMPRESA */}
        <Link to="/ajustes/empresa" className="glass-box nav-card">
          <div className="nav-icon">🏢</div>
          <h3
            style={{
              marginBottom: 6,
              color: "rgba(255,255,255,0.92)",
              fontWeight: 700,
            }}
          >
            Datos de Empresa
          </h3>
          <p style={{ opacity: 0.87, color: "rgba(255,255,255,0.85)" }}>
            Logo, dirección, IBAN, numeración, datos legales.
          </p>
        </Link>

        {/* FORMAS DE PAGO */}
        <Link to="/ajustes/pagos" className="glass-box nav-card">
          <div className="nav-icon">💳</div>
          <h3
            style={{
              marginBottom: 6,
              color: "rgba(255,255,255,0.92)",
              fontWeight: 700,
            }}
          >
            Formas de Pago
          </h3>
          <p style={{ opacity: 0.87, color: "rgba(255,255,255,0.85)" }}>
            Gestiona las opciones que aparecerán en facturas y presupuestos.
          </p>
        </Link>

        {/* CONFIGURACIÓN EMAIL */}
        <div
          className="glass-box nav-card"
          onClick={() => setView("email")}
          style={{ cursor: "pointer" }}
        >
          <div className="nav-icon">📧</div>
          <h3
            style={{
              marginBottom: 6,
              color: "rgba(255,255,255,0.92)",
              fontWeight: 700,
            }}
          >
            Configuración de Email
          </h3>
          <p style={{ opacity: 0.87, color: "rgba(255,255,255,0.85)" }}>
            SMTP, credenciales y remitente.
          </p>
        </div>

        {/* USUARIOS */}
<Link to="/ajustes/usuarios" className="glass-box nav-card">
  <div className="nav-icon">👥</div>
  <h3 style={{ marginBottom: 6, color: "rgba(255,255,255,0.92)", fontWeight: 700 }}>
    Usuarios
  </h3>
  <p style={{ opacity: 0.87, color: "rgba(255,255,255,0.85)" }}>
    Gestión de usuarios y contraseñas
  </p>
</Link>

        {/* IMPUESTOS (PRÓXIMAMENTE) */}
        <div className="glass-box nav-card" style={{ opacity: 0.6 }}>
          <div className="nav-icon">⚖️</div>
          <h3
            style={{ marginBottom: 6, color: "rgba(255,255,255,0.92)", fontWeight: 700 }}
          >
            Impuestos
          </h3>
          <p style={{ color: "rgba(255,255,255,0.8)" }}>
            Reglas por país / cliente
          </p>
          <span className="soon-badge">Próximamente</span>
        </div>
      </nav>
    </div>
  );
}
